import { gql, useMutation } from '@apollo/client';
import { useToast } from '@chakra-ui/react';
import log from '~/log';

const PublishEvent = gql`
    mutation PublishEvent($event: EventInput!) {
        publish(event: $event) {
            EventId
        }
    }
`;

export function usePublishEvent() {
    const [publishEventMutation, { loading }] = useMutation(PublishEvent);
    const toast = useToast();

    async function publishEvent(event: {
        source: string;
        name: string;
        payload: Record<string, unknown>;
    }) {
        const response = await publishEventMutation({
            mutation: PublishEvent,
            variables: {
                event: {
                    source: event.source,
                    name: event.name,
                    payload: JSON.stringify(event.payload),
                },
            },
        });
        toast({
            title: 'Termin wurde gesendet',
            status: 'success',
            duration: 2000,
            isClosable: true,
        });
        log.debug('publishEvent response', response);
    }

    return { publishEvent, isPublishing: loading };
}
